/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as msRest from "@azure/ms-rest-js";
import * as Models from "./models";
import * as Mappers from "./models/mappers";
import * as Parameters from "./models/parameters";
import { ApiContext } from "./apiContext";
var Api = /** @class */ (function (_super) {
    __extends(Api, _super);
    /**
     * Initializes a new instance of the Api class.
     * @param [options] The parameter options
     */
    function Api(options) {
        return _super.call(this, options) || this;
    }
    Api.prototype.getTenantApplicationsAddressFormLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsAddressFormLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsAdverseReactionLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsAdverseReactionLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsAdverseReactionProductsPartialSet = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsAdverseReactionProductsPartialSetOperationSpec, callback);
    };
    Api.prototype.getTenantProductAvailability = function (tenant, productCode, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            productCode: productCode,
            options: options
        }, getTenantProductAvailabilityOperationSpec, callback);
    };
    Api.prototype.getTenantConceptAvailability = function (tenant, conceptCode, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            conceptCode: conceptCode,
            options: options
        }, getTenantConceptAvailabilityOperationSpec, callback);
    };
    Api.prototype.getTenantBackInStockNotificationsConfiguration = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantBackInStockNotificationsConfigurationOperationSpec, callback);
    };
    Api.prototype.getTenantBazaarvoiceConfiguration = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantBazaarvoiceConfigurationOperationSpec, callback);
    };
    Api.prototype.getBeautyRewardPointsTenantLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getBeautyRewardPointsTenantLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantBrands = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantBrandsOperationSpec, callback);
    };
    Api.prototype.getTenantBrand = function (tenant, brandId, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            brandId: brandId,
            options: options
        }, getTenantBrandOperationSpec, callback);
    };
    Api.prototype.getTenantBrandDynamiclink = function (tenant, brandId, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            brandId: brandId,
            options: options
        }, getTenantBrandDynamiclinkOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsBreadcrumbLinks = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsBreadcrumbLinksOperationSpec, callback);
    };
    Api.prototype.getTenantRewardShopConfigurations = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantRewardShopConfigurationsOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsCatalogueIPaperConfiguration = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsCatalogueIPaperConfigurationOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsCatalogueOverview = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsCatalogueOverviewOperationSpec, callback);
    };
    Api.prototype.getTenantCatalogues = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantCataloguesOperationSpec, callback);
    };
    Api.prototype.getTenantCatalogueDynamiclink = function (tenant, catalogueId, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            catalogueId: catalogueId,
            options: options
        }, getTenantCatalogueDynamiclinkOperationSpec, callback);
    };
    Api.prototype.getTenantSocialMediaLibraryCategory = function (tenant, categoryId, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            categoryId: categoryId,
            options: options
        }, getTenantSocialMediaLibraryCategoryOperationSpec, callback);
    };
    Api.prototype.getTenantSocialMediaLibraryCategories = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantSocialMediaLibraryCategoriesOperationSpec, callback);
    };
    Api.prototype.getTenantCategories = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantCategoriesOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsChatBotMetadata = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsChatBotMetadataOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsChatBotPageMetadata = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsChatBotPageMetadataOperationSpec, callback);
    };
    Api.prototype.getTenantCommissionPlanType = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantCommissionPlanTypeOperationSpec, callback);
    };
    Api.prototype.getTenantConceptIndexItems = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantConceptIndexItemsOperationSpec, callback);
    };
    Api.prototype.getTenantConceptLabels = function (tenant, conceptCodes, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            conceptCodes: conceptCodes,
            options: options
        }, getTenantConceptLabelsOperationSpec, callback);
    };
    Api.prototype.getTenantDeprecatedConcept = function (tenant, conceptCode, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            conceptCode: conceptCode,
            options: options
        }, getTenantDeprecatedConceptOperationSpec, callback);
    };
    Api.prototype.getTenantConcept = function (tenant, conceptCode, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            conceptCode: conceptCode,
            options: options
        }, getTenantConceptOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsMv7ModulesConceptsRepositoryConcepts = function (tenant, conceptCodes, lang, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            conceptCodes: conceptCodes,
            lang: lang,
            options: options
        }, getTenantApplicationsMv7ModulesConceptsRepositoryConceptsOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsMv7ModulesConceptsRepositoryConceptsHashCodes = function (tenant, conceptCodes, lang, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            conceptCodes: conceptCodes,
            lang: lang,
            options: options
        }, getTenantApplicationsMv7ModulesConceptsRepositoryConceptsHashCodesOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsMv7ModulesConceptsLabelsRepositoryConceptsLabels = function (tenant, conceptCodes, lang, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            conceptCodes: conceptCodes,
            lang: lang,
            options: options
        }, getTenantApplicationsMv7ModulesConceptsLabelsRepositoryConceptsLabelsOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsConcernReportFormLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsConcernReportFormLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsConcernReportFormConfiguration = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsConcernReportFormConfigurationOperationSpec, callback);
    };
    Api.prototype.getConsultantInfoTenantLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getConsultantInfoTenantLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantCustomerRegistrationsMetadatumContactDetailsMetadata = function (tenant, registrationType, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            registrationType: registrationType,
            options: options
        }, getTenantCustomerRegistrationsMetadatumContactDetailsMetadataOperationSpec, callback);
    };
    Api.prototype.getTenantCountries = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantCountriesOperationSpec, callback);
    };
    Api.prototype.getTenantCulture = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantCultureOperationSpec, callback);
    };
    Api.prototype.getTenantCustomerConfirmationMetadata = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantCustomerConfirmationMetadataOperationSpec, callback);
    };
    Api.prototype.getTenantDocumentTypes = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantDocumentTypesOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsEarningsAppLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsEarningsAppLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantECatalogueSearchResult = function (tenant, eCatalogueId, query, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            eCatalogueId: eCatalogueId,
            query: query,
            options: options
        }, getTenantECatalogueSearchResultOperationSpec, callback);
    };
    Api.prototype.getTenantECatalogueStructure = function (tenant, eCatalogueId, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            eCatalogueId: eCatalogueId,
            options: options
        }, getTenantECatalogueStructureOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsEditorialEditorialPages = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsEditorialEditorialPagesOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsEditorialHeaders = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsEditorialHeadersOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsEditorialProductBoxCarousels = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsEditorialProductBoxCarouselsOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsEditorialArticleCarousels = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsEditorialArticleCarouselsOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsEditorialOlapics = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsEditorialOlapicsOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsEditorialBanners = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsEditorialBannersOperationSpec, callback);
    };
    Api.prototype.getTenantEditorialArticles = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantEditorialArticlesOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsEInvoiceLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsEInvoiceLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsEndCustomerReferralDiscountLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsEndCustomerReferralDiscountLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantSystemEndpointsIdentityServer = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantSystemEndpointsIdentityServerOperationSpec, callback);
    };
    Api.prototype.getTenantSystemEndpointsOnline = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantSystemEndpointsOnlineOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsExternalCampaignAppExternalCampaigns = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsExternalCampaignAppExternalCampaignsOperationSpec, callback);
    };
    Api.prototype.getTenantCustomerExternalProfilesMetadata = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantCustomerExternalProfilesMetadataOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsFooter = function (tenant, lang, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            lang: lang,
            options: options
        }, getTenantApplicationsFooterOperationSpec, callback);
    };
    Api.prototype.getTenantProductsFormattedPrices = function (tenant, productCodes, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            productCodes: productCodes,
            options: options
        }, getTenantProductsFormattedPricesOperationSpec, callback);
    };
    Api.prototype.getTenantConceptsFormattedPrices = function (tenant, conceptCodes, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            conceptCodes: conceptCodes,
            options: options
        }, getTenantConceptsFormattedPricesOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsFrontPageProductStandards = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsFrontPageProductStandardsOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsFrontPageMotivationContent = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsFrontPageMotivationContentOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsFrontPageBeautyEdit = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsFrontPageBeautyEditOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsFrontPageVipBenefits = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsFrontPageVipBenefitsOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsFrontPageTopBrands = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsFrontPageTopBrandsOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsFrontPageBeautyVideo = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsFrontPageBeautyVideoOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsFrontPageBenefitBanner = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsFrontPageBenefitBannerOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsFrontPageNotificationBanner = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsFrontPageNotificationBannerOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsFrontPage = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsFrontPageOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsGenesysWidgetMetadata = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsGenesysWidgetMetadataOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsGenesysWidgetPageMetadata = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsGenesysWidgetPageMetadataOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsGuaranteeCreditLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsGuaranteeCreditLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsGuaranteeCreditGrantedCreditConfiguration = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsGuaranteeCreditGrantedCreditConfigurationOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsMV7Homepage = function (tenant, lang, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            lang: lang,
            options: options
        }, getTenantApplicationsMV7HomepageOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsMV7Usersegmenttypes = function (tenant, lang, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            lang: lang,
            options: options
        }, getTenantApplicationsMV7UsersegmenttypesOperationSpec, callback);
    };
    Api.prototype.getTenantSocialMediaLibraryImageInfo = function (tenant, imageInfoId, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            imageInfoId: imageInfoId,
            options: options
        }, getTenantSocialMediaLibraryImageInfoOperationSpec, callback);
    };
    Api.prototype.getTenantSocialMediaLibraryImageInfos = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantSocialMediaLibraryImageInfosOperationSpec, callback);
    };
    Api.prototype.getTenantIngredients = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantIngredientsOperationSpec, callback);
    };
    Api.prototype.getTenantIngredient = function (tenant, ingredientName, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            ingredientName: ingredientName,
            options: options
        }, getTenantIngredientOperationSpec, callback);
    };
    Api.prototype.getTenantIngredientsInspirations = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantIngredientsInspirationsOperationSpec, callback);
    };
    Api.prototype.getTenantInviteFriendConfiguration = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantInviteFriendConfigurationOperationSpec, callback);
    };
    Api.prototype.getTenantInviteFriendLink = function (tenant, consultantNumber, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            consultantNumber: consultantNumber,
            options: options
        }, getTenantInviteFriendLinkOperationSpec, callback);
    };
    Api.prototype.getTenantJoiningFeeDialogHtml = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantJoiningFeeDialogHtmlOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsFooterLanguageConfiguration = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsFooterLanguageConfigurationOperationSpec, callback);
    };
    Api.prototype.getTenantLanguages = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantLanguagesOperationSpec, callback);
    };
    Api.prototype.getTenantCustomerRegistrationsMetadatumLegalDetailsMetadata = function (tenant, registrationType, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            registrationType: registrationType,
            options: options
        }, getTenantCustomerRegistrationsMetadatumLegalDetailsMetadataOperationSpec, callback);
    };
    Api.prototype.getTenantLookbooks = function (tenant, skip, top, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            skip: skip,
            top: top,
            options: options
        }, getTenantLookbooksOperationSpec, callback);
    };
    Api.prototype.getTenantLookbookBanners = function (tenant, skip, top, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            skip: skip,
            top: top,
            options: options
        }, getTenantLookbookBannersOperationSpec, callback);
    };
    Api.prototype.getTenantLookbookEditorialArticlesCarousels = function (tenant, skip, top, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            skip: skip,
            top: top,
            options: options
        }, getTenantLookbookEditorialArticlesCarouselsOperationSpec, callback);
    };
    Api.prototype.getTenantLookbookProductBoxCarousels = function (tenant, skip, top, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            skip: skip,
            top: top,
            options: options
        }, getTenantLookbookProductBoxCarouselsOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsMakeupTryOnConfiguration = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsMakeupTryOnConfigurationOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsMakeupTryOnProductsRelation = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsMakeupTryOnProductsRelationOperationSpec, callback);
    };
    Api.prototype.getTenantMobileApps = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantMobileAppsOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsMobileAppsPageHeader = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsMobileAppsPageHeaderOperationSpec, callback);
    };
    Api.prototype.getTenantMobileAppsLinks = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantMobileAppsLinksOperationSpec, callback);
    };
    Api.prototype.getMyBusinessTenantLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getMyBusinessTenantLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsMV7NavigationCategory = function (tenant, lang, category, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            lang: lang,
            category: category,
            options: options
        }, getTenantApplicationsMV7NavigationCategoryOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsMV7NavigationBrand = function (tenant, lang, brand, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            lang: lang,
            brand: brand,
            options: options
        }, getTenantApplicationsMV7NavigationBrandOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsMV7NavigationCategoryConcepts = function (tenant, category, lang, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            category: category,
            lang: lang,
            options: options
        }, getTenantApplicationsMV7NavigationCategoryConceptsOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsMV7NavigationBrandConcepts = function (tenant, brand, lang, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            brand: brand,
            lang: lang,
            options: options
        }, getTenantApplicationsMV7NavigationBrandConceptsOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsNavigationNavigation = function (tenant, navigationType, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            navigationType: navigationType,
            options: options
        }, getTenantApplicationsNavigationNavigationOperationSpec, callback);
    };
    Api.prototype.getTenantNavigationTag = function (tenant, relatedCategory, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            relatedCategory: relatedCategory,
            options: options
        }, getTenantNavigationTagOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsNewsletterSubscriptionConfiguration = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsNewsletterSubscriptionConfigurationOperationSpec, callback);
    };
    Api.prototype.getNotificationsTenantLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getNotificationsTenantLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsAdvisorNovAgeSkincareConfiguration = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsAdvisorNovAgeSkincareConfigurationOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsOlapicConfiguration = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsOlapicConfigurationOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsOnboardingLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsOnboardingLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsOrderHistoryLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsOrderHistoryLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantPageMetaData = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantPageMetaDataOperationSpec, callback);
    };
    Api.prototype.getTenantPeriodsCurrentPeriod = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantPeriodsCurrentPeriodOperationSpec, callback);
    };
    Api.prototype.getTenantProductPermission = function (tenant, productCode, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            productCode: productCode,
            options: options
        }, getTenantProductPermissionOperationSpec, callback);
    };
    Api.prototype.getTenantConceptPermission = function (tenant, conceptCode, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            conceptCode: conceptCode,
            options: options
        }, getTenantConceptPermissionOperationSpec, callback);
    };
    Api.prototype.getPersonalBeautyStoreTenantLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getPersonalBeautyStoreTenantLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantCustomerRegistrationsMetadatumPersonalDetailsMetadata = function (tenant, registrationType, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            registrationType: registrationType,
            options: options
        }, getTenantCustomerRegistrationsMetadatumPersonalDetailsMetadataOperationSpec, callback);
    };
    Api.prototype.getPersonalGroupListingTenantLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getPersonalGroupListingTenantLocalizationOperationSpec, callback);
    };
    Api.prototype.getPersonalGroupOverviewTenantLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getPersonalGroupOverviewTenantLocalizationOperationSpec, callback);
    };
    Api.prototype.getApplicationsPersonalMenuTenantLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getApplicationsPersonalMenuTenantLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantPopularProducts = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantPopularProductsOperationSpec, callback);
    };
    Api.prototype.getTenantProductPrice = function (tenant, productCode, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            productCode: productCode,
            options: options
        }, getTenantProductPriceOperationSpec, callback);
    };
    Api.prototype.getTenantConceptPrice = function (tenant, conceptCode, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            conceptCode: conceptCode,
            options: options
        }, getTenantConceptPriceOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsProductBox = function (tenant, productCodes, lang, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            productCodes: productCodes,
            lang: lang,
            options: options
        }, getTenantApplicationsProductBoxOperationSpec, callback);
    };
    Api.prototype.getTenantProductBundle = function (tenant, productCode, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            productCode: productCode,
            options: options
        }, getTenantProductBundleOperationSpec, callback);
    };
    Api.prototype.getTenantProductBundles = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantProductBundlesOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsProductDetailConfiguration = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsProductDetailConfigurationOperationSpec, callback);
    };
    Api.prototype.getTenantProductIndexItems = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantProductIndexItemsOperationSpec, callback);
    };
    Api.prototype.getTenantProductLabelsContent = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantProductLabelsContentOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsMV7Productlistings = function (tenant, lang, id, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            lang: lang,
            id: id,
            options: options
        }, getTenantApplicationsMV7ProductlistingsOperationSpec, callback);
    };
    Api.prototype.getTenantDeprecatedProduct = function (tenant, productCode, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            productCode: productCode,
            options: options
        }, getTenantDeprecatedProductOperationSpec, callback);
    };
    Api.prototype.getTenantProductDynamiclink = function (tenant, productCode, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            productCode: productCode,
            options: options
        }, getTenantProductDynamiclinkOperationSpec, callback);
    };
    Api.prototype.getTenantProduct = function (tenant, productCode, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            productCode: productCode,
            options: options
        }, getTenantProductOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsMv7ModulesProductsRepositoryProducts = function (tenant, productCodes, lang, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            productCodes: productCodes,
            lang: lang,
            options: options
        }, getTenantApplicationsMv7ModulesProductsRepositoryProductsOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsMv7ModulesProductsRepositoryProductsHashCodes = function (tenant, productCodes, lang, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            productCodes: productCodes,
            lang: lang,
            options: options
        }, getTenantApplicationsMv7ModulesProductsRepositoryProductsHashCodesOperationSpec, callback);
    };
    Api.prototype.getTenantProductsExpectedInbounds = function (tenant, productCodes, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            productCodes: productCodes,
            options: options
        }, getTenantProductsExpectedInboundsOperationSpec, callback);
    };
    Api.prototype.getTenantProductsIngredients = function (tenant, productCodes, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            productCodes: productCodes,
            options: options
        }, getTenantProductsIngredientsOperationSpec, callback);
    };
    Api.prototype.getTenantProductsLabels = function (tenant, productCodes, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            productCodes: productCodes,
            options: options
        }, getTenantProductsLabelsOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsMv7ModulesProductsLabelsRepositoryProductsLabels = function (tenant, productCodes, lang, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            productCodes: productCodes,
            lang: lang,
            options: options
        }, getTenantApplicationsMv7ModulesProductsLabelsRepositoryProductsLabelsOperationSpec, callback);
    };
    Api.prototype.getTenantProductsManufacturers = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantProductsManufacturersOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsMv7ModulesProductsPricesRepositoryProductsPrices = function (tenant, productCodes, lang, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            productCodes: productCodes,
            lang: lang,
            options: options
        }, getTenantApplicationsMv7ModulesProductsPricesRepositoryProductsPricesOperationSpec, callback);
    };
    Api.prototype.getTenantProductsReplacements = function (tenant, productCodes, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            productCodes: productCodes,
            options: options
        }, getTenantProductsReplacementsOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsProfileLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsProfileLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantPromotionsBannersBestoffers = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantPromotionsBannersBestoffersOperationSpec, callback);
    };
    Api.prototype.getTenantPromotionsBannersWhatsnew = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantPromotionsBannersWhatsnewOperationSpec, callback);
    };
    Api.prototype.getTenantPromotionsBannersHero = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantPromotionsBannersHeroOperationSpec, callback);
    };
    Api.prototype.getTenantPromotionsBannersCampaign = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantPromotionsBannersCampaignOperationSpec, callback);
    };
    Api.prototype.getTenantPromotionsBannersCategory = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantPromotionsBannersCategoryOperationSpec, callback);
    };
    Api.prototype.getTenantDigitalPromotions = function (tenant, channel, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            channel: channel,
            options: options
        }, getTenantDigitalPromotionsOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsRealTimeOrderTrackingLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsRealTimeOrderTrackingLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantRealtimeOrderTracking = function (tenant, orderId, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            orderId: orderId,
            options: options
        }, getTenantRealtimeOrderTrackingOperationSpec, callback);
    };
    Api.prototype.getTenantCustomerRegistrationsMetadatumRegistrationsMetadata = function (tenant, registrationType, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            registrationType: registrationType,
            options: options
        }, getTenantCustomerRegistrationsMetadatumRegistrationsMetadataOperationSpec, callback);
    };
    Api.prototype.getTenantProductRelations = function (tenant, productCode, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            productCode: productCode,
            options: options
        }, getTenantProductRelationsOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsReportsSpaMetadata = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsReportsSpaMetadataOperationSpec, callback);
    };
    Api.prototype.getTenantSample = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantSampleOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsMV7FacetSettings = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsMV7FacetSettingsOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsSimplifiedRegistrationBrandPartnerLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsSimplifiedRegistrationBrandPartnerLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsSimplifiedRegistrationVipCustomerLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsSimplifiedRegistrationVipCustomerLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantSocialMediaLinks = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantSocialMediaLinksOperationSpec, callback);
    };
    Api.prototype.getTenantCustomerRegistrationsMetadatumSponsorDetailsMetadata = function (tenant, registrationType, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            registrationType: registrationType,
            options: options
        }, getTenantCustomerRegistrationsMetadatumSponsorDetailsMetadataOperationSpec, callback);
    };
    Api.prototype.getTenantStepsToSuccessPhases = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantStepsToSuccessPhasesOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsStepsToSuccessLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsStepsToSuccessLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantSubscriptionTypes = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantSubscriptionTypesOperationSpec, callback);
    };
    Api.prototype.getTenantSubscriptionReplacements = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantSubscriptionReplacementsOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsSubscriptionWizardLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsSubscriptionWizardLocalizationOperationSpec, callback);
    };
    Api.prototype.getApplicationsSupportCenterTenantLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getApplicationsSupportCenterTenantLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantTagGroups = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantTagGroupsOperationSpec, callback);
    };
    Api.prototype.getTargetListTenantLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTargetListTenantLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantTermHtml = function (tenant, termId, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            termId: termId,
            options: options
        }, getTenantTermHtmlOperationSpec, callback);
    };
    Api.prototype.getTestTenantPing = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTestTenantPingOperationSpec, callback);
    };
    Api.prototype.getTenantThirdPartyConfiguration = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantThirdPartyConfigurationOperationSpec, callback);
    };
    Api.prototype.getTitleProgressTenantLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTitleProgressTenantLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantTranslationsDeprecated = function (tenant, keys, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            keys: keys,
            options: options
        }, getTenantTranslationsDeprecatedOperationSpec, callback);
    };
    Api.prototype.getTenantVipCustomerBanner = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantVipCustomerBannerOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsVipUpgradeLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsVipUpgradeLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsVouchersLocalization = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsVouchersLocalizationOperationSpec, callback);
    };
    Api.prototype.getTenantApplicationsWellnessClubBanners = function (tenant, options, callback) {
        return this.sendOperationRequest({
            tenant: tenant,
            options: options
        }, getTenantApplicationsWellnessClubBannersOperationSpec, callback);
    };
    return Api;
}(ApiContext));
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var getTenantApplicationsAddressFormLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/addressForm/localization",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticNotificationsLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsAdverseReactionLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/adverseReaction/localization",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticNotificationsLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsAdverseReactionProductsPartialSetOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/adverseReaction/productsPartialSet",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.codeStartsWith,
        Parameters.itemType,
        Parameters.categories,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsAdverseReactionProductAdrDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantProductAvailabilityOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/products/{productCode}/availability",
    urlParameters: [
        Parameters.tenant,
        Parameters.productCode0
    ],
    queryParameters: [
        Parameters.atpClusterId,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticProductsAvailabilityDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantConceptAvailabilityOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/concepts/{conceptCode}/availability",
    urlParameters: [
        Parameters.tenant,
        Parameters.conceptCode
    ],
    queryParameters: [
        Parameters.atpClusterId,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticConceptsConceptAvailabilityDto
        },
        404: {},
        default: {}
    },
    serializer: serializer
};
var getTenantBackInStockNotificationsConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/backInStockNotificationsConfiguration",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticBackInStockNotificationsConfigurationBackInStockNotificationsConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantBazaarvoiceConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/bazaarvoice/configuration",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticBazaarvoiceBazaarVoiceConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getBeautyRewardPointsTenantLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "beautyRewardPoints/tenants/{tenant}/localization",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticNotificationsLocalizationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getTenantBrandsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/brands",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.categoryId0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticProductsBrandsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantBrandOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/brands/{brandId}",
    urlParameters: [
        Parameters.tenant,
        Parameters.brandId
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticProductsBrandDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantBrandDynamiclinkOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/brands/{brandId}/dynamiclink",
    urlParameters: [
        Parameters.tenant,
        Parameters.brandId
    ],
    queryParameters: [
        Parameters.lang0,
        Parameters.clientApplication,
        Parameters.invite,
        Parameters.storename
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticDynamicLinksDynamicLinkDto
        },
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsBreadcrumbLinksOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/breadcrumb/links",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.pageUrl,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsBreadcrumbsBreadcrumbsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantRewardShopConfigurationsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/rewardShopConfigurations",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.customerCategory
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticCampaignsRewardShopConfigurationsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsCatalogueIPaperConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/catalogueIPaper/configuration",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsCatalogueIPaperConfigurationCatalogueIPaperConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsCatalogueOverviewOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/catalogueOverview",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0,
        Parameters.customerTypeId0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsCatalogueOverviewCatalogueOverviewDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantCataloguesOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/catalogues",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.periodId,
        Parameters.typeCode
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticCataloguesCataloguesDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getTenantCatalogueDynamiclinkOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/catalogues/{catalogueId}/dynamiclink",
    urlParameters: [
        Parameters.tenant,
        Parameters.catalogueId
    ],
    queryParameters: [
        Parameters.lang0,
        Parameters.clientApplication,
        Parameters.invite,
        Parameters.storename,
        Parameters.page
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticDynamicLinksDynamicLinkDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getTenantSocialMediaLibraryCategoryOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/socialMediaLibrary/categories/{categoryId}",
    urlParameters: [
        Parameters.tenant,
        Parameters.categoryId1
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticSocialMediaLibraryCategoryDto
        },
        404: {},
        default: {}
    },
    serializer: serializer
};
var getTenantSocialMediaLibraryCategoriesOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/socialMediaLibrary/categories",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0,
        Parameters.top0,
        Parameters.skip0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticSocialMediaLibraryCategoriesDto
        },
        404: {},
        default: {}
    },
    serializer: serializer
};
var getTenantCategoriesOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/categories",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticProductsCategoriesDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsChatBotMetadataOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/chatBot/metadata",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsChatBotChatBotMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsChatBotPageMetadataOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/chatBot/pageMetadata",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.url,
        Parameters.visitorSegment1,
        Parameters.isUserAuthenticated
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticControllersApplicationsChatBotChatBotPageMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantCommissionPlanTypeOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/commissionPlanType",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.periodId
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticBonusesCommissionPlanTypeDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getTenantConceptIndexItemsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/conceptIndexItems",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.conceptCodes0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticConceptIndexItemsConceptIndexItemsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantConceptLabelsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/conceptLabels",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.conceptCodes1,
        Parameters.conceptLabelDomains,
        Parameters.atpClusterId,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticConceptsConceptsLabelsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantDeprecatedConceptOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/deprecatedConcepts/{conceptCode}",
    urlParameters: [
        Parameters.tenant,
        Parameters.conceptCode
    ],
    queryParameters: [
        Parameters.atpClusterId,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticDeprecatedConceptDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getTenantConceptOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/concepts/{conceptCode}",
    urlParameters: [
        Parameters.tenant,
        Parameters.conceptCode
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticConceptsConceptDto
        },
        401: {},
        403: {},
        404: {},
        406: {},
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsMv7ModulesConceptsRepositoryConceptsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/mv7/modules/conceptsRepository/concepts",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.conceptCodes1,
        Parameters.lang1,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.useProductService,
        Parameters.usePascalCaseResponseFormat
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticSharedGraphQlResponseDto1StaticMV7ConceptsConceptsDtoStaticVersion1000CultureneutralPublicKeyTokennull
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsMv7ModulesConceptsRepositoryConceptsHashCodesOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/mv7/modules/conceptsRepository/conceptsHashCodes",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.conceptCodes1,
        Parameters.lang1,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.useProductService,
        Parameters.usePascalCaseResponseFormat
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticSharedGraphQlResponseDto1StaticMV7ConceptsHashCodesConceptsHashCodesDtoStaticVersion1000CultureneutralPublicKeyTokennull
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsMv7ModulesConceptsLabelsRepositoryConceptsLabelsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/mv7/modules/conceptsLabelsRepository/conceptsLabels",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.conceptCodes1,
        Parameters.lang1,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.atpClusterId,
        Parameters.usePascalCaseResponseFormat
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticSharedGraphQlResponseDto1StaticMV7ConceptsLabelsConceptsLabelsResponseDtoStaticVersion1000CultureneutralPublicKeyTokennull
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsConcernReportFormLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/concernReportForm/localization",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsConcernReportFormLocalizationConcernReportFormLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsConcernReportFormConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/concernReportForm/configuration",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsConcernReportFormConfigurationConcernReportFormConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getConsultantInfoTenantLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "consultantInfo/tenants/{tenant}/localization",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticNotificationsLocalizationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getTenantCustomerRegistrationsMetadatumContactDetailsMetadataOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/customerRegistrationsMetadata/{registrationType}/contactDetailsMetadata",
    urlParameters: [
        Parameters.tenant,
        Parameters.registrationType
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticCustomerRegistrationsMetadataRegistrationContactDetailsMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantCountriesOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/countries",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticCountriesCountriesDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantCultureOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/culture",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticCultureTenantCultureDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantCustomerConfirmationMetadataOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/customerConfirmationMetadata",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticCustomerConfirmationMetadataCustomerConfirmationMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantDocumentTypesOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/documentTypes",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "StaticDocumentsDocumentTypeDto"
                        }
                    }
                }
            }
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsEarningsAppLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/earningsApp/localization",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsSharedLocalizationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getTenantECatalogueSearchResultOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/eCatalogueSearchResults/{eCatalogueId}",
    urlParameters: [
        Parameters.tenant,
        Parameters.eCatalogueId
    ],
    queryParameters: [
        Parameters.query
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticECatalogueSearchSearchResultRootDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantECatalogueStructureOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/eCatalogueStructures/{eCatalogueId}",
    urlParameters: [
        Parameters.tenant,
        Parameters.eCatalogueId
    ],
    queryParameters: [
        Parameters.includeIndexedText,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticECatalogueStructureECatalogueStructureDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsEditorialEditorialPagesOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/editorial/editorialPages",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.channel0,
        Parameters.editorialPageIds,
        Parameters.top1,
        Parameters.skip1,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsEditorialEditorialPagesCollectionDto
        },
        400: {},
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsEditorialHeadersOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/editorial/headers",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.headerIds,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsEditorialHeaderCollectionDto
        },
        400: {},
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsEditorialProductBoxCarouselsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/editorial/productBoxCarousels",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.productBoxCarouselIds,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsEditorialProductBoxCarouselCollectionDto
        },
        400: {},
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsEditorialArticleCarouselsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/editorial/articleCarousels",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.articleIds,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsEditorialArticleCarouselCollectionDto
        },
        400: {},
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsEditorialOlapicsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/editorial/olapics",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.olapicIds,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsEditorialOlapicCollectionDto
        },
        400: {},
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsEditorialBannersOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/editorial/banners",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.bannerIds,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsEditorialEditorialBannerCollectionDto
        },
        400: {},
        default: {}
    },
    serializer: serializer
};
var getTenantEditorialArticlesOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/editorialArticles",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.articleType,
        Parameters.productCodes0,
        Parameters.relatedArticlesUrls,
        Parameters.skip0,
        Parameters.top2,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticEditorialArticlesEditorialArticlesDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsEInvoiceLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/eInvoice/localization",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsSharedLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsEndCustomerReferralDiscountLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/endCustomerReferralDiscount/localization",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsSharedLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantSystemEndpointsIdentityServerOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/system/endpoints/identityServer",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticSystemIdentityServerEndpointsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantSystemEndpointsOnlineOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/system/endpoints/online",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticSystemOnlineEndpointsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsExternalCampaignAppExternalCampaignsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/externalCampaignApp/externalCampaigns",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.externalCampaignUrls,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsExternalCampaignsExternalCampaignsCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantCustomerExternalProfilesMetadataOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/customerExternalProfilesMetadata",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticCustomerExternalProfilesMetadataExternalProfilesMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsFooterOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/footer",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang1,
        Parameters.atpClusterId,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.usePascalCaseResponseFormat
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticSharedGraphQlResponseDto1StaticApplicationsFooterBffFooterDtoStaticVersion1000CultureneutralPublicKeyTokennull
        },
        default: {}
    },
    serializer: serializer
};
var getTenantProductsFormattedPricesOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/productsFormattedPrices",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.productCodes1,
        Parameters.atpClusterId,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticProductsProductFormattedPricesDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantConceptsFormattedPricesOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/conceptsFormattedPrices",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.conceptCodes1,
        Parameters.atpClusterId,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticProductsConceptFormattedPricesDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsFrontPageProductStandardsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/frontPage/productStandards",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsFrontpageV3ProductStandardsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsFrontPageMotivationContentOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/frontPage/motivationContent",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsFrontpageV3MotivationContentDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsFrontPageBeautyEditOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/frontPage/beautyEdit",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsFrontpageV3BeautyEditDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsFrontPageVipBenefitsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/frontPage/vipBenefits",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsFrontpageV3VipBenefitsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsFrontPageTopBrandsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/frontPage/topBrands",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsFrontpageV3TopBrandsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsFrontPageBeautyVideoOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/frontPage/beautyVideo",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsFrontpageV3BeautyVideoDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsFrontPageBenefitBannerOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/frontPage/benefitBanner",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0,
        Parameters.visitorSegment0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsFrontpageV3BenefitBannerDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsFrontPageNotificationBannerOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/frontPage/notificationBanner",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsFrontpageV3NotificationBannerDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsFrontPageOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/frontPage",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.atpClusterId,
        Parameters.usePascalCaseResponseFormat
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticSharedGraphQlResponseDto1StaticApplicationsFrontpageV3BffFrontPageDtoStaticVersion1000CultureneutralPublicKeyTokennull
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsGenesysWidgetMetadataOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/genesysWidget/metadata",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsGenesysWidgetGenesysWidgetMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsGenesysWidgetPageMetadataOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/genesysWidget/pageMetadata",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.url,
        Parameters.isUserAuthenticated
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsGenesysWidgetGenesysWidgetPageMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsGuaranteeCreditLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/guaranteeCredit/localization",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsSharedLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsGuaranteeCreditGrantedCreditConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/guaranteeCredit/grantedCreditConfiguration",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsGuaranteeCreditGrantedCreditConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsMV7HomepageOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/MV7/homepage",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang1,
        Parameters.userSegment
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticMV7HomepageHomepageDto
        },
        404: {},
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsMV7UsersegmenttypesOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/MV7/usersegmenttypes",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang1
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticMV7HomepageUserSegmentTypeDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantSocialMediaLibraryImageInfoOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/socialMediaLibrary/imageInfos/{imageInfoId}",
    urlParameters: [
        Parameters.tenant,
        Parameters.imageInfoId
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticSocialMediaLibraryImageInfoDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getTenantSocialMediaLibraryImageInfosOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/socialMediaLibrary/imageInfos",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.top0,
        Parameters.skip0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticSocialMediaLibraryImageInfosDto
        },
        404: {},
        default: {}
    },
    serializer: serializer
};
var getTenantIngredientsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/ingredients",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.ingredientNames,
        Parameters.top1,
        Parameters.skip1,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticIngredientLibraryIngredientsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantIngredientOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/ingredients/{ingredientName}",
    urlParameters: [
        Parameters.tenant,
        Parameters.ingredientName
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticIngredientLibraryIngredientDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantIngredientsInspirationsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/ingredientsInspirations",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticIngredientsInspirationsIngredientsInspirationsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantInviteFriendConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/inviteFriendConfiguration",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticInviteFriendConfigurationConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantInviteFriendLinkOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/inviteFriendLinks/{consultantNumber}",
    urlParameters: [
        Parameters.tenant,
        Parameters.consultantNumber
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticSharedLinkDto
        },
        404: {},
        default: {}
    },
    serializer: serializer
};
var getTenantJoiningFeeDialogHtmlOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/joiningFeeDialog/html",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticJoiningFeeDialogJoiningFeeDialogHtmlDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsFooterLanguageConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/footer/languageConfiguration",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsFooterLanguageConfigurationLanguageConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantLanguagesOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/languages",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticLanguagesLanguagesDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantCustomerRegistrationsMetadatumLegalDetailsMetadataOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/customerRegistrationsMetadata/{registrationType}/legalDetailsMetadata",
    urlParameters: [
        Parameters.tenant,
        Parameters.registrationType
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticCustomerRegistrationsMetadataRegistrationLegalDetailsMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantLookbooksOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/lookbooks",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lookbookIds,
        Parameters.skip2,
        Parameters.top3,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticLookbookLookbooksDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantLookbookBannersOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/lookbookBanners",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lookbookBannerIds,
        Parameters.skip2,
        Parameters.top3,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticLookbookBannerLookbookBannersDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantLookbookEditorialArticlesCarouselsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/lookbookEditorialArticlesCarousels",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lookbookEditorialArticlesCarouselIds,
        Parameters.skip2,
        Parameters.top3,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticLookbookEditorialArticlesCarouselsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantLookbookProductBoxCarouselsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/lookbookProductBoxCarousels",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lookbookProductBoxCarouselIds,
        Parameters.skip2,
        Parameters.top3,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticLookbookLookbookProductBoxCarouselsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsMakeupTryOnConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/makeupTryOn/configuration",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsMakeupTryOnMakeupTryOnConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsMakeupTryOnProductsRelationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/makeupTryOn/productsRelation",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.productCodes0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsMakeupTryOnMakeupTryOnProductsRelationsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantMobileAppsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/mobileApps",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticMobileAppsMobileAppsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsMobileAppsPageHeaderOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/mobileApps/pageHeader",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticMobileAppsMobileAppsDownloadPageHeaderDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantMobileAppsLinksOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/mobileAppsLinks",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticMobileAppsMobileAppsLinksDto
        },
        default: {}
    },
    serializer: serializer
};
var getMyBusinessTenantLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "myBusiness/tenants/{tenant}/localization",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticNotificationsLocalizationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsMV7NavigationCategoryOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/MV7/navigationCategories/{category}",
    urlParameters: [
        Parameters.tenant,
        Parameters.category
    ],
    queryParameters: [
        Parameters.lang1,
        Parameters.depth,
        Parameters.skipEmpty,
        Parameters.isSample,
        Parameters.isConsultantsOnly
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticMV7NavigationCategoryNavigationTreeDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsMV7NavigationBrandOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/MV7/navigationBrands/{brand}",
    urlParameters: [
        Parameters.tenant,
        Parameters.brand
    ],
    queryParameters: [
        Parameters.lang1,
        Parameters.depth,
        Parameters.skipEmpty,
        Parameters.isSample,
        Parameters.isConsultantsOnly
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticMV7NavigationBrandNavigationTreeDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsMV7NavigationCategoryConceptsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/MV7/navigationCategories/{category}/concepts",
    urlParameters: [
        Parameters.tenant,
        Parameters.category
    ],
    queryParameters: [
        Parameters.lang1,
        Parameters.filterParams,
        Parameters.facetField,
        Parameters.skip0,
        Parameters.take,
        Parameters.sort,
        Parameters.customerTypeId1,
        Parameters.warehouseId
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticMV7NavigationConceptsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsMV7NavigationBrandConceptsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/MV7/navigationBrands/{brand}/concepts",
    urlParameters: [
        Parameters.tenant,
        Parameters.brand
    ],
    queryParameters: [
        Parameters.lang1,
        Parameters.filterParams,
        Parameters.facetField,
        Parameters.skip0,
        Parameters.take,
        Parameters.sort,
        Parameters.customerTypeId1,
        Parameters.warehouseId
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticMV7NavigationConceptsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsNavigationNavigationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/navigation/navigations/{navigationType}",
    urlParameters: [
        Parameters.tenant,
        Parameters.navigationType
    ],
    queryParameters: [
        Parameters.excludeChildren,
        Parameters.nodeId,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticNavigationNavigationCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantNavigationTagOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/navigationTags/{relatedCategory}",
    urlParameters: [
        Parameters.tenant,
        Parameters.relatedCategory
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticNavigationNavigationTagsCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsNewsletterSubscriptionConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/newsletterSubscription/Configuration",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsNewsletterSubsciptionConfigurationNewsletterSubscriptionConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getNotificationsTenantLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "notifications/tenants/{tenant}/localization",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticNotificationsLocalizationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsAdvisorNovAgeSkincareConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/advisor/novAgeSkincareConfiguration",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsAdvisorNovAgeSkincareConfigurationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsOlapicConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/olapic/configuration",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.olapicType,
        Parameters.productCode1,
        Parameters.categoryId0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticOlapicOlapicConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsOnboardingLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/onboarding/localization",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticNotificationsLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsOrderHistoryLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/orderHistory/localization",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticNotificationsLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantPageMetaDataOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/pageMetaData",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.pageId,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticPageMetaDataPageMetaDataDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantPeriodsCurrentPeriodOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/periods/currentPeriod",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticBonusesCurrentPeriodDto
        },
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getTenantProductPermissionOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/products/{productCode}/permission",
    urlParameters: [
        Parameters.tenant,
        Parameters.productCode0
    ],
    queryParameters: [
        Parameters.atpClusterId,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticProductsPermissionDto
        },
        404: {},
        default: {}
    },
    serializer: serializer
};
var getTenantConceptPermissionOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/concepts/{conceptCode}/permission",
    urlParameters: [
        Parameters.tenant,
        Parameters.conceptCode
    ],
    queryParameters: [
        Parameters.atpClusterId,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticConceptsPermissionDto
        },
        404: {},
        default: {}
    },
    serializer: serializer
};
var getPersonalBeautyStoreTenantLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "personalBeautyStore/tenants/{tenant}/localization",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticNotificationsLocalizationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getTenantCustomerRegistrationsMetadatumPersonalDetailsMetadataOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/customerRegistrationsMetadata/{registrationType}/personalDetailsMetadata",
    urlParameters: [
        Parameters.tenant,
        Parameters.registrationType
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticCustomerRegistrationsMetadataRegistrationPersonalDetailsMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getPersonalGroupListingTenantLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "personalGroupListing/tenants/{tenant}/localization",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticNotificationsLocalizationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getPersonalGroupOverviewTenantLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "personalGroupOverview/tenants/{tenant}/localization",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticNotificationsLocalizationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsPersonalMenuTenantLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/personalMenu/tenants/{tenant}/localization",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticNotificationsLocalizationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getTenantPopularProductsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/popularProducts",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.type,
        Parameters.categoryId0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticPopularProductsProductCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantProductPriceOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/products/{productCode}/price",
    urlParameters: [
        Parameters.tenant,
        Parameters.productCode0
    ],
    queryParameters: [
        Parameters.atpClusterId,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticProductsProductPriceDto
        },
        404: {},
        default: {}
    },
    serializer: serializer
};
var getTenantConceptPriceOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/concepts/{conceptCode}/price",
    urlParameters: [
        Parameters.tenant,
        Parameters.conceptCode
    ],
    queryParameters: [
        Parameters.atpClusterId,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticConceptsConceptPriceDto
        },
        404: {},
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsProductBoxOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/productBox",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.productCodes1,
        Parameters.lang1,
        Parameters.atpClusterId,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.usePascalCaseResponseFormat
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticSharedGraphQlResponseDto1StaticApplicationsProductBoxProductBoxDtoStaticVersion1000CultureneutralPublicKeyTokennull
        },
        default: {}
    },
    serializer: serializer
};
var getTenantProductBundleOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/productBundles/{productCode}",
    urlParameters: [
        Parameters.tenant,
        Parameters.productCode0
    ],
    queryParameters: [
        Parameters.atpClusterId,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticProductsProductBundleDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantProductBundlesOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/productBundles",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.includedProducts,
        Parameters.productCodes0,
        Parameters.atpClusterId,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticProductsProductBundlesDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsProductDetailConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/productDetail/configuration",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsProductDetailsProductDetailConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantProductIndexItemsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/productIndexItems",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.productCodes0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticProductIndexItemsProductIndexItemsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantProductLabelsContentOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/productLabelsContent",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticProductsProductLabelsContentCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsMV7ProductlistingsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/MV7/productlistings",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang1,
        Parameters.id
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticMV7ProductListingsProductListingPromosDto
        },
        404: {},
        default: {}
    },
    serializer: serializer
};
var getTenantDeprecatedProductOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/deprecatedProducts/{productCode}",
    urlParameters: [
        Parameters.tenant,
        Parameters.productCode0
    ],
    queryParameters: [
        Parameters.atpClusterId,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticDeprecatedProductDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getTenantProductDynamiclinkOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/products/{productCode}/dynamiclink",
    urlParameters: [
        Parameters.tenant,
        Parameters.productCode0
    ],
    queryParameters: [
        Parameters.lang0,
        Parameters.clientApplication,
        Parameters.invite,
        Parameters.storename
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticDynamicLinksDynamicLinkDto
        },
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getTenantProductOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/products/{productCode}",
    urlParameters: [
        Parameters.tenant,
        Parameters.productCode0
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticProductsProductDto
        },
        401: {},
        403: {},
        404: {},
        406: {},
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsMv7ModulesProductsRepositoryProductsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/mv7/modules/productsRepository/products",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.productCodes1,
        Parameters.lang1,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.useProductService,
        Parameters.usePascalCaseResponseFormat
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticSharedGraphQlResponseDto1StaticMV7ProductsProductsDtoStaticVersion1000CultureneutralPublicKeyTokennull
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsMv7ModulesProductsRepositoryProductsHashCodesOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/mv7/modules/productsRepository/productsHashCodes",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.productCodes1,
        Parameters.lang1,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.useProductService,
        Parameters.usePascalCaseResponseFormat
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticSharedGraphQlResponseDto1StaticMV7ProductsHashCodesProductsHashCodesDtoStaticVersion1000CultureneutralPublicKeyTokennull
        },
        default: {}
    },
    serializer: serializer
};
var getTenantProductsExpectedInboundsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/productsExpectedInbounds",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.productCodes1,
        Parameters.atpClusterId,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticProductsExpectedInboundsProductsExpectedInboundsCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantProductsIngredientsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/productsIngredients",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.productCodes1,
        Parameters.atpClusterId,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticProductsIngredientsProductsIngredientsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantProductsLabelsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/productsLabels",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.productCodes1,
        Parameters.productLabelDomains,
        Parameters.atpClusterId,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticProductsProductsLabelsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsMv7ModulesProductsLabelsRepositoryProductsLabelsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/mv7/modules/productsLabelsRepository/productsLabels",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.productCodes1,
        Parameters.lang1,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.atpClusterId,
        Parameters.usePascalCaseResponseFormat
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticSharedGraphQlResponseDto1StaticMV7ProductsLabelsProductsLabelsResponseDtoStaticVersion1000CultureneutralPublicKeyTokennull
        },
        default: {}
    },
    serializer: serializer
};
var getTenantProductsManufacturersOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/productsManufacturers",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.manufacturerIds,
        Parameters.atpClusterId,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticProductsManufacturersProductsManufacturersDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsMv7ModulesProductsPricesRepositoryProductsPricesOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/mv7/modules/productsPricesRepository/productsPrices",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.productCodes1,
        Parameters.lang1,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.usePascalCaseResponseFormat
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticSharedGraphQlResponseDto1StaticMV7ProductsPricesProductsPricesDtoStaticVersion1000CultureneutralPublicKeyTokennull
        },
        default: {}
    },
    serializer: serializer
};
var getTenantProductsReplacementsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/productsReplacements",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.productCodes1,
        Parameters.atpClusterId,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticProductsReplacementsProductsReplacementsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsProfileLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/profile/localization",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticNotificationsLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantPromotionsBannersBestoffersOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/promotions/banners/bestoffers",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.bannerIds,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticDigitalPromotionsBestOffersBannersDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantPromotionsBannersWhatsnewOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/promotions/banners/whatsnew",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.bannerIds,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticDigitalPromotionsWhatsNewBannersDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantPromotionsBannersHeroOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/promotions/banners/hero",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.bannerIds,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticDigitalPromotionsHeroBannersDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantPromotionsBannersCampaignOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/promotions/banners/campaign",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.bannerIds,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticDigitalPromotionsCampaignBannersDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantPromotionsBannersCategoryOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/promotions/banners/category",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.bannerIds,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticDigitalPromotionsCategoryBannersDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantDigitalPromotionsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/digitalPromotions",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.promotionTypes,
        Parameters.channel1,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticDigitalPromotionsCurrentPromotionsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsRealTimeOrderTrackingLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/realTimeOrderTracking/localization",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsSharedLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantRealtimeOrderTrackingOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/realtimeOrderTrackings/{orderId}",
    urlParameters: [
        Parameters.tenant,
        Parameters.orderId
    ],
    queryParameters: [
        Parameters.accessKey
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticShoppingOrderTrackingsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantCustomerRegistrationsMetadatumRegistrationsMetadataOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/customerRegistrationsMetadata/{registrationType}/registrationsMetadata",
    urlParameters: [
        Parameters.tenant,
        Parameters.registrationType
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticCustomerRegistrationsMetadataRegistrationMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantProductRelationsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/products/{productCode}/relations",
    urlParameters: [
        Parameters.tenant,
        Parameters.productCode0
    ],
    queryParameters: [
        Parameters.relationTypes,
        Parameters.atpClusterId,
        Parameters.customerTypeId0,
        Parameters.visitorSegment0,
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticProductsRelationsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsReportsSpaMetadataOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/reportsSpa/metadata",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsReportsReportsMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantSampleOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/sample",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticSampleSampleDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsMV7FacetSettingsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/MV7/facetSettings",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticMV7SettingsFacetSettingsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsSimplifiedRegistrationBrandPartnerLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/simplifiedRegistration/brandPartnerLocalization",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticNotificationsLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsSimplifiedRegistrationVipCustomerLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/simplifiedRegistration/vipCustomerLocalization",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticNotificationsLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantSocialMediaLinksOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/socialMediaLinks",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticSocialMediaLinksSocialMediaLinkCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantCustomerRegistrationsMetadatumSponsorDetailsMetadataOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/customerRegistrationsMetadata/{registrationType}/sponsorDetailsMetadata",
    urlParameters: [
        Parameters.tenant,
        Parameters.registrationType
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticCustomerRegistrationsMetadataRegistrationSponsorDetailsMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantStepsToSuccessPhasesOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/stepsToSuccessPhases",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.skip0,
        Parameters.top4
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticStepsToSuccessAllStepsToSuccessTaskPhasesDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsStepsToSuccessLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/stepsToSuccess/localization",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticNotificationsLocalizationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getTenantSubscriptionTypesOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/subscriptionTypes",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticSubscriptionsSubscriptionTypesDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantSubscriptionReplacementsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/subscriptionReplacements",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.itemCodes
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticSubscriptionsSubscriptionReplacementsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsSubscriptionWizardLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/subscriptionWizard/localization",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsSharedLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsSupportCenterTenantLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/supportCenter/tenants/{tenant}/localization",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticNotificationsLocalizationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getTenantTagGroupsOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/tagGroups",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticTagsTagGroupsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTargetListTenantLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "targetList/tenants/{tenant}/localization",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticNotificationsLocalizationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getTenantTermHtmlOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/terms/{termId}/html",
    urlParameters: [
        Parameters.tenant,
        Parameters.termId
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticTermsTermHtmlDto
        },
        default: {}
    },
    serializer: serializer
};
var getTestTenantPingOperationSpec = {
    httpMethod: "GET",
    path: "test/tenants/{tenant}/ping",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticTestTestDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantThirdPartyConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/thirdPartyConfiguration",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticThirdPartyConfigurationThirdPartyConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getTitleProgressTenantLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "titleProgress/tenants/{tenant}/localization",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticNotificationsLocalizationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getTenantTranslationsDeprecatedOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/translations",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.keys
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Dictionary",
                    value: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        },
        default: {}
    },
    serializer: serializer
};
var getTenantVipCustomerBannerOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/vipCustomerBanner",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsVipCustomerBannerVipCustomerBannerDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsVipUpgradeLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/vipUpgrade/localization",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticNotificationsLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsVouchersLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/vouchers/localization",
    urlParameters: [
        Parameters.tenant
    ],
    queryParameters: [
        Parameters.lang0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsSharedLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getTenantApplicationsWellnessClubBannersOperationSpec = {
    httpMethod: "GET",
    path: "tenants/{tenant}/applications/WellnessClub/banners",
    urlParameters: [
        Parameters.tenant
    ],
    responses: {
        200: {
            bodyMapper: Mappers.StaticApplicationsWellnessClubBannersDto
        },
        default: {}
    },
    serializer: serializer
};
export { Api, ApiContext, Models as ApiModels, Mappers as ApiMappers };

//# sourceMappingURL=api.js.map
